export default __webpack_public_path__ + "static/media/rocket_anim_139.ccefa646.png";